import { action } from 'mobx'
import { StoreExt } from '@utils/reactExt'
import { IButtonLog, IReferrerLog } from '@protocol/log'
import { isMobile } from 'react-device-detect'
import { DEVICE_TYPE } from '@v2/constants/common'

export class LogStore extends StoreExt {

  @action
  fetchReferrer = async (params: IReferrerLog.Params) => {
    await this.api.log.doReferrerLog(params)
  }

  writeButtonLog = async (params: {
    pageId: string, buttonId: string, buttonDetails?: string,
  }): Promise<IButtonLog.Schema> => {
    const { pageId, buttonId, buttonDetails } = params
    const deviceType = isMobile  ? DEVICE_TYPE.MOBILE : DEVICE_TYPE.PC
    const data: IButtonLog.Params = { deviceType, pageId, buttonId, buttonDetails }
    return this.api.log.writeButtonLog(data)
  }
}

export default new LogStore()
